import styles from './GeoHeader.module.scss'
import {  useGeoState } from '../../../components/GeoProvider'
import DefaultBreadcrumbs from '../../../components/Breadcrumbs/DefaultBreadcrumbs'

const Header = ({ headerType, geo_id }) => {
  
     const { locationName } = useGeoState()
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_parent={headerType}
            geo_id={geo_id}
            geo_type={'county'}
            dashboardType={'birthtrend'}
          />
         
        </div>
        <div className={styles.geoName}>{locationName}</div>
        
      </div>
    </>
  )
}
export default Header
